import { render } from "./Astronaut.vue?vue&type=template&id=13ee6be3&scoped=true"
const script = {}

import "./Astronaut.vue?vue&type=style&index=0&id=13ee6be3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ee6be3"]])

export default __exports__